import { MapObject } from '../../types/general';
import { isProperValue, isNullOrUndefined } from '../type/typeUtil';

export const cloneOnlyProperValues = (obj: MapObject): MapObject => {
    return Object
        .entries(obj)
        .reduce((accumulator: MapObject, entry: any[]) => {
            const [key, val] = entry;
            if (isProperValue(val)) {
                accumulator[key] = val;
            }
            return accumulator;
        }, {});
};

export const hasOwnProp = (property: string | number, obj: object): boolean => {
    return Object.prototype.hasOwnProperty.call(obj, property);
};

export const propsAreIdentical = (propNames: string[], obj1: MapObject, obj2: MapObject) => {
    return !propNames.some((propName) => obj1[propName] !== obj2[propName]);
};

export const getValueFromPath = (path: string, data: Record<string, any>) => {
    let searchObject: any = null;
    if (path && data && Object.entries(data).length > 0) {
        searchObject = data;
        path.split('.').forEach((element: string) => {
            if (!isNullOrUndefined(searchObject[element])) {
                searchObject = searchObject[element];
            }
        });
    }

    return searchObject;
};

export const removeEmptyValue = (object: Record<string, any>) => {
    Object.keys(object).forEach((key) => {
        if ((typeof object[key] === 'number' ? isNaN(object[key]) : object[key] === '')) {
            delete object[key];
        }
    });
};

export const isPlainObject = (value: any): value is MapObject => typeof value === 'object' && value !== null && !Array.isArray(value);

const objectUtil = {
    cloneOnlyProperValues,
    hasOwnProp,
    propsAreIdentical,
    getValueFromPath,
    removeEmptyValue,
    isPlainObject,
};

export default objectUtil;
